import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as GlobalVariables from '../globals/globals';
import * as $ from 'jquery';

@Component({
  selector: 'app-sdg-header',
  templateUrl: './sdg-header.component.html',
  styleUrls: ['./sdg-header.component.css']
})
export class SdgHeaderComponent implements OnInit, OnDestroy {
    is_country_fp = false;
    lang = 1;
    private guideOffsetAnimationFrameId: number | null = null;
    
    // Navigation translations
    navTranslations = {
      resource: {
        1: 'Resource',
        2: 'Ressources',
        3: 'Recursos',
        4: 'Recursos',
        5: '리소스',
        6: 'الموارد'
      }
    };
    
    constructor(private router: Router) { }

    ngOnInit() {
        var currentUserId = JSON.parse(localStorage.getItem('currentUserId'));
        if(currentUserId)
          this.is_country_fp = currentUserId.country_focal_point;
        
        // Initialize language
        this.lang = GlobalVariables.findTranslationOptionsIndex(window);
        this.startGuidePanelOffsetTracking();
    }

    ngOnDestroy() {
      if (this.guideOffsetAnimationFrameId !== null) {
        window.cancelAnimationFrame(this.guideOffsetAnimationFrameId);
        this.guideOffsetAnimationFrameId = null;
      }
    }

    @HostListener('window:scroll')
    onWindowScroll() {
      this.updateGuidePanelOffset();
    }

    @HostListener('window:resize')
    onWindowResize() {
      this.updateGuidePanelOffset();
    }

    private startGuidePanelOffsetTracking() {
      const update = () => {
        this.updateGuidePanelOffset();
        this.guideOffsetAnimationFrameId = window.requestAnimationFrame(update);
      };

      this.updateGuidePanelOffset();
      if (this.guideOffsetAnimationFrameId === null) {
        this.guideOffsetAnimationFrameId = window.requestAnimationFrame(update);
      }
    }

    private updateGuidePanelOffset() {
      const navbar = document.querySelector('.navbar.navbar-custom') as HTMLElement;
      let offset = 0;

      if (navbar) {
        const navbarRect = navbar.getBoundingClientRect();
        if (navbarRect.bottom > 0) {
          offset = Math.ceil(navbarRect.bottom);
        }
      }

      document.documentElement.style.setProperty('--sdg-navbar-offset', `${offset}px`);
    }
    
    // Helper method to get translated navigation text
    getNavTranslation(key: string): string {
      return this.navTranslations[key][this.lang] || this.navTranslations[key][1];
    }

    logoutClick(){
        localStorage.setItem('editmode', '0');
        this.router.navigateByUrl('/login')
    }
    profileClick(){
        this.router.navigateByUrl('/profile')
    }
    register1Click(){
        this.router.navigateByUrl('/register')
    }
    feedbackClick(){
        this.router.navigateByUrl('/feedback')
    }
    manageTeamClick(){
        this.router.navigateByUrl('/manage-team')
    }
    homeBtnClick(){
        this.router.navigateByUrl('/home')
    }
    capacityBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".capacity-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/capacity-quest')
    }
    statusBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".status-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/status-quest')
    }
    financeBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".finance-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/finance-quest')
    }
    integrityBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".integrity-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/transparency-quest')
    }
    genderBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".gender-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/gender-quest')
    }
    policyBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".policy-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/policy-quest')
    }
    resilienceBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".resilience-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/resilience-quest')
    }
    resourceBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".resource-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/resource-quest')
    }
      profileIconClick(){
    $('.dropdown-content').slideToggle(400, 'swing');
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/sdg-header/sdg-header.component.ts